import jwtDecode from "jwt-decode";
import { Outlet, Navigate, history } from "./AppRouter";
import store from "../store/store";
import { setSearch } from "../store/actions/setSearch";
import { FC, useState, useEffect } from "react";
import {
  authenticated,
  tryAutoLogin,
  ensureSharedCookiesOrLogout,
} from "../utils/auth";

const setFilters = () => {
  if (history.location.search !== "") {
    const token = jwtDecode(history.location.search);
    store.dispatch(setSearch({ type: "setPaginationControl", payload: token }));
  } else {
    store.dispatch(setSearch({ type: "totalReset" }));
  }
};

interface Props {
  redirectPath: string;
  children: any;
}

const ProtectedRoute: FC<Props> = ({ redirectPath = "/login", children }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      // Si hay sesión abierta pero faltan las cookies compartidas requeridas,
      // forzar logout y detener el flujo de autenticación.
      if (!ensureSharedCookiesOrLogout() && authenticated()) {
        setIsAuthenticated(false);
        setIsChecking(false);
        return;
      }

      // Primero verificar si ya está autenticado
      if (authenticated()) {
        setIsAuthenticated(true);
        setIsChecking(false);
        return;
      }

      // Si no está autenticado, intentar login automático
      const autoLoginSuccess = await tryAutoLogin();
      
      if (autoLoginSuccess && authenticated()) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
      
      setIsChecking(false);
    };

    checkAuth();
  }, []);

  if (isChecking) {
    // Mostrar un loader mientras se verifica la autenticación
    return null; // O puedes retornar un componente de loading
  }

  if (isAuthenticated) {
    try {
      setFilters();
    } catch (e) {
      console.error(e);
    }

    return children ? children : <Outlet />;
  }
  
  // Guardar la URL actual para redirigir después del login
  const currentPath = history.location.pathname + history.location.search;
  const loginPath = redirectPath.includes('?') 
    ? `${redirectPath}&redirect=${encodeURIComponent(currentPath)}`
    : `${redirectPath}?redirect=${encodeURIComponent(currentPath)}`;
  
  return <Navigate to={loginPath} replace />;
};

export default ProtectedRoute;
